import { TemplateContextProvider } from 'components/ui/composed/template/TemplateContext';
import { Dispatch, ReactElement, SetStateAction, useState } from 'react';
import { Outlet } from 'react-router-dom';
import useTemplateFilters, { TemplateFilters } from './useTemplateFilters';

export enum FormSection {
    MASTER_DETAILS = 0,
    PRODUCTS = 1,
}

export type TemplatesOutletContext = {
    filters: TemplateFilters;
    archived: boolean;
    setArchived: Dispatch<SetStateAction<boolean>>;
};

// The dashboard is unmounted while the template builder is open, so the params applied to the
// list are kept here, where they survive until the dashboard is shown again.
const TemplateView = (): ReactElement => {
    const filters = useTemplateFilters({});
    const [archived, setArchived] = useState(false);

    return (
        <TemplateContextProvider>
            <Outlet context={{ filters, archived, setArchived }} />
        </TemplateContextProvider>
    );
};

export default TemplateView;
